import { useSuperAdminAuth } from '../context/SuperAdminAuthContext';

export const usePermission = () => {
  const { superAdmin } = useSuperAdminAuth();

  const hasPermission = (permissionKey) => {
    if (!superAdmin) return false;

    // Super Admin has unrestricted access to all features
    if (superAdmin.role_type === 'superadmin' || (superAdmin.permissions && superAdmin.permissions.includes('*'))) {
      return true;
    }

    if (Array.isArray(superAdmin.permissions)) {
      return superAdmin.permissions.includes(permissionKey);
    }

    return false;
  };

  const hasModulePermission = (moduleName) => {
    if (!superAdmin) return false;
    if (superAdmin.role_type === 'superadmin' || (superAdmin.permissions && superAdmin.permissions.includes('*'))) {
      return true;
    }

    if (Array.isArray(superAdmin.permissions)) {
      return superAdmin.permissions.some(p => p.startsWith(`${moduleName}.`));
    }

    return false;
  };

  return {
    hasPermission,
    hasModulePermission,
    isSuperAdmin: superAdmin?.role_type === 'superadmin'
  };
};

export default usePermission;
